import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

export const drawerWidth = 200; //px

//use them as css values
export const successColor = (theme) => green[600];
export const errorColor = (theme) => theme.palette.error.dark;
export const infoColor = (theme) => theme.palette.primary.dark;
export const warningColor = (theme) => amber[700];